import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {Box} from "@mui/material";


export default function BudgetStatus(props) {
   const formatCurrency = (amount) => `$${amount.toFixed(2)}`;

   const remaining = props.totalBudget - props.categorizedSpend - props.otherSpend;

   return (
      // Outer Box still handles the overall component height/flexGrow
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
         <Paper
            elevation={3}
            sx={{
               flexGrow: 1,
               p: 2, // Padding inside Paper
               display: 'flex',
               flexDirection: 'column', // Stack the line items vertically
               gap: 1.5 // Add some vertical space between lines
            }}
         >
            {/* Use the helper component for each line */}
            <DottedLineItem
               label="Budget"
               value={formatCurrency(props.totalBudget)}
               labelVariant="h6" // Example: Make Budget line stand out
               valueVariant="h6"
            />
            <DottedLineItem
               label="Budgeted Spend"
               value={formatCurrency(props.categorizedSpend)}
            />
            <DottedLineItem
               label="Other Spend"
               value={formatCurrency(props.otherSpend)}
            />

            {/* Spacer to push remaining to bottom */}
            {/*<Box sx={{ flexGrow: 1 }} />*/}

            <DottedLineItem
               label="Remaining"
               value={formatCurrency(remaining)}
               labelVariant="h6"
               valueVariant="h6"
               // sx={{ marginTop: 'auto' }} // Keep this line at the bottom
            />

         </Paper>
      </Box>
   );
}



function DottedLineItem({ label, value, labelVariant = "body1", valueVariant = "body1", sx = {} }) {
   return (
      <Box
         sx={{
            display: 'grid',
            // Columns: Label (auto) | Dots (fills space) | Value (auto)
            gridTemplateColumns: 'auto 1fr auto',
            alignItems: 'baseline', // Align text along their baseline
            gap: 1, // Gap between columns (theme.spacing unit)
            width: '100%', // Ensure the grid takes full width
            ...sx // Allow passing extra styles
         }}
      >
         {/* Column 1: Label */}
         <Typography variant={labelVariant} sx={{ whiteSpace: 'nowrap' }}>
            {label}
         </Typography>

         {/* Column 2: Dots (using a border on a Box) */}
         <Box
            sx={{
               // Adjust border style and margin/positioning for vertical alignment
               borderBottom: '2px dotted #bdbdbd', // Grey dots
               marginBottom: '5px', // Adjust this value to align dots with text baseline
            }}
         />

         {/* Column 3: Value */}
         <Typography variant={valueVariant} sx={{ whiteSpace: 'nowrap', fontWeight: 'medium' /* Optional */ }}>
            {value}
         </Typography>
      </Box>
   );
}